module.exports = __webpack_public_path__ + "img/upload-minimize.84286a41.svg";